import { DmsType } from "@domain/models/dms";
import { type TBindSubType } from "@dms/types";
import { use } from "react";
import { CompanyContext } from "@domain/context/CompanyContext";
import { DmsTypesContext } from "@domain/context/DmsDataContexts";

export const useBindSubtype = (id: string, type: TBindSubType): string | undefined => {
    const { companyGQL } = use(CompanyContext);
    const { documentTypes } = use(DmsTypesContext);

    if (type === DmsType.Bank) {
        if (!companyGQL?.bankList || !companyGQL?.bankList.length) {
            return undefined;
        }

        const bankId: string = companyGQL.bankList.filter((el) => el.id === id)[0]?.id;

        if (!bankId) {
            return undefined;
        }

        const bank = documentTypes.find((el) => el.id === type);
        return bank.subTypes.find((el) => el.bankId === bankId)?.id;
    }

    if (type === DmsType.KB) {
        if (!companyGQL?.kasseList || !companyGQL?.kasseList.length) {
            return undefined;
        }

        const kbId: string = companyGQL.kasseList.filter((el) => el.id === id)[0]?.id;

        if (!kbId) {
            return undefined;
        }

        const kb = documentTypes.find((el) => el.id === type);
        return kb.subTypes.find((el) => el.kbId === kbId)?.id;
    }
    return undefined;
};
